import React, { FC } from 'react';
import { MemoryRouter } from 'react-router';
import { MainSource } from '../../../../constants/Source';
import { useSourceState } from '../../../../containers/FilesImporter/hooks/useSourceState';
import { useFileType } from '../../../../utils/hooks/bi/useFileType';
import { RouteBuilder } from '../../../../utils/RouteHelpers';
import styles from './AddFilesToBoardModal.scss';
import { IOuter } from './AddFilesToBoardModal.types';
import { SiteFilesViewer } from './SiteFilesViewer';

const initialEntries = [RouteBuilder.AddFilesToBoardModal()];

export const AddFilesToBoardModal: FC<IOuter> = ({ boards, onSelectItems }) => {
  const { disconnect } = useSourceState();
  const fileType = useFileType();

  return (
    <div className={styles.modal}>
      <MemoryRouter initialEntries={initialEntries}>
        <SiteFilesViewer
          boards={boards}
          source={MainSource.SiteFiles}
          fileType={fileType}
          onSourceSessionExpired={disconnect}
          className={styles.wrapper}
          onSelectItems={onSelectItems}
        />
      </MemoryRouter>
    </div>
  );
};
